// src/features/landing/presentation/components/PartnershipIntroSection.jsx
import React from "react";
import "./PartnershipIntroSection.css";

export function PartnershipIntroSection() {
    const valuePropositions = [
        {
            id: 1,
            text: "라이징브로커즈는 GA 전문 인력 매칭 플랫폼으로 성장하고 있습니다.",
        },
        {
            id: 2,
            text: "단순한 중개를 넘어, 모두가 함께 만족하는 혁신적인 구조를 만듭니다.",
        },
        {
            id: 3,
            text: "그리고 이 작은 연결이 모여, 보험업계 전반에 긍정적인 변화를 만들어 갑니다.",
        },
    ];

    return (
        <section className="partnership-intro-section">
            <div className="intro-container">
                <div className="intro-header">
                    <h1 className="header-title">
                        보험업계의 새로운 표준,{" "}
                        <span className="title-highlight">
                            지금 파트너십을 시작하세요!
                        </span>
                    </h1>
                </div>

                <div className="value-propositions">
                    {valuePropositions.map((item) => (
                        <div key={item.id} className="proposition-box">
                            <p className="proposition-text">
                                <span className="proposition-number">{item.id})</span>{" "}
                                {item.text}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="intro-footer">
                    <p className="footer-message">
                        GA 전문 인력 매칭의 든든한 파트너,{" "}
                        <span className="brand-name">라이징브로커즈</span>
                    </p>
                </div>
            </div>
        </section>
    );
}
